class MainMenuSceneUniversal extends Phaser.Scene {
  constructor() {
    super({ key: 'MainMenuSceneUniversal' });
    this.overlayId = 'main-menu-universal-overlay';
    this.sceneReady = false;
    this.eventListenersAttached = false;
    this.retriedEventAttachment = false; // Prevent infinite retry loops
  }

  create() {
    console.log("MainMenuSceneUniversal: Starting universal landing page...");
    
    // CRITICAL FIX: Reset all state flags on every create (important for ribbon navigation)
    this.sceneReady = false;
    this.eventListenersAttached = false;
    this.retriedEventAttachment = false; // Reset retry flag for fresh start
    console.log("MainMenuSceneUniversal: All state flags reset for fresh initialization");
    
    // Initialize Phaser scene properties first to satisfy SceneManager checks
    this.cameras.main.setBackgroundColor('#0f172a');
    
    // Create a full-screen background to satisfy camera and background checks
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    this.add.rectangle(width / 2, height / 2, width, height, 0x0f172a, 1).setOrigin(0.5).setDepth(-1000);
    
    // Force camera update to ensure cameraReady check passes
    this.cameras.main.centerOn(width / 2, height / 2);
    this.cameras.main.setScroll(0, 0);
    
    console.log("MainMenuSceneUniversal: Phaser scene initialization complete");
    console.log("MainMenuSceneUniversal: Camera dimensions:", {
      width: this.cameras.main.width,
      height: this.cameras.main.height,
      centerX: this.cameras.main.centerX,
      centerY: this.cameras.main.centerY
    });
    
    // Hide game container for DOM interface
    this.hideGameContainer();
    
    // Create the professional landing page
    this.createUniversalLandingPage();
    
    // Set scene as ready after brief delay to prevent auto-clicking
    setTimeout(() => {
      this.sceneReady = true;
      console.log("✅ MainMenuSceneUniversal: Scene ready for interactions");
      
      // Enable input management for professional experience
      if (this.input && typeof this.input.enabled !== 'undefined') {
        this.input.enabled = true;
        console.log("✅ MainMenuSceneUniversal: Phaser input enabled");
      }
      
      // Signal to UIController that scene is ready
      if (window.UIController && typeof window.UIController.setActiveScene === 'function') {
        window.UIController.setActiveScene(this);
        console.log("✅ MainMenuSceneUniversal: UIController scene reference updated");
      }
      
      // Signal scene is fully initialized
      this.scene.setVisible(true);
      this.scene.setActive(true);
      
    }, 100); // Reduced delay for faster response
  }

  createUniversalLandingPage() {
    console.log("MainMenuSceneUniversal: Creating landing page...");
    
    // CRITICAL FIX: Remove any existing overlay and clean up previous DOM elements
    this.removeExistingOverlay();
    
    // Remove any stray DOM elements from previous instances
    const existingElements = document.querySelectorAll('#signInBtn, #signUpBtn, #pptHeroCard, #classifyTechCard, #philosophyFlowCard, #slideWarsCard');
    if (existingElements.length > 0) {
      console.log(`MainMenuSceneUniversal: Cleaning up ${existingElements.length} existing DOM elements from previous instance`);
      existingElements.forEach(element => {
        if (element.parentElement && element.parentElement.id !== this.overlayId) {
          element.remove();
        }
      });
    }

    // Create main overlay container
    const overlay = document.createElement('div');
    overlay.id = this.overlayId;
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
      z-index: 10000;
      overflow-y: auto;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      color: white;
    `;

    // Add professional styles
    this.addUniversalStyles();

    // Create the complete landing page
    overlay.innerHTML = `
      <div class="header">
        <div class="logo">DeckOps.ai</div>
        <div class="auth-buttons">
          <button class="auth-button" id="signInBtn">Sign In</button>
          <button class="auth-button primary" id="signUpBtn">Get Started</button>
        </div>
      </div>

      <div class="hero-section">
        <h1 class="hero-title">Executive Performance Intelligence</h1>
        <p class="hero-subtitle">Master the digital tools that drive executive excellence. From PowerPoint mastery to strategic thinking, elevate your professional capabilities.</p>
        
        <div class="cta-buttons">
          <button class="cta-button primary" id="startTrialBtn">Start Free Trial</button>
          <button class="cta-button secondary" id="exploreBtn">Explore Platform</button>
        </div>
      </div>

      <div class="games-section">
        <h2 class="section-title">Performance Modules</h2>
        <p class="section-subtitle">Choose your path to executive excellence</p>

        <div class="guest-notice">
          <h3>🎯 Guest Access Available</h3>
          <p>Experience our training modules with limited access. Sign up for full analytics, progress tracking, and firm-specific content.</p>
        </div>

        <div class="games-grid">
          <div class="game-card" id="pptHeroCard">
            <div class="game-header">
              <div class="game-icon">📊</div>
              <div class="game-status available">Available</div>
            </div>
            <h3 class="game-title">PPT Hero</h3>
            <p class="game-description">Master PowerPoint shortcuts and presentation workflows. Learn universal skills plus firm-specific consulting techniques.</p>
            <div class="game-features">
              <span class="feature-tag">Keyboard Mastery</span>
              <span class="feature-tag">Firm-Specific</span>
              <span class="feature-tag">Analytics</span>
            </div>
            <button class="game-action play">Play Now</button>
            
            <div class="preview-overlay">
              <div class="preview-content">
                <div class="preview-title">PowerPoint Excellence</div>
                <div class="preview-text">Speed, accuracy, and shortcut mastery training</div>
              </div>
            </div>
          </div>

          <div class="game-card locked" id="slideWarsCard">
            <div class="game-header">
              <div class="game-icon">⚔️</div>
              <div class="game-status locked">Login Required</div>
            </div>
            <h3 class="game-title">Slide Wars</h3>
            <p class="game-description">Competitive presentation building under time pressure. Battle other executives in real-time slide creation challenges.</p>
            <div class="game-features">
              <span class="feature-tag">Multiplayer</span>
              <span class="feature-tag">Real-time</span>
              <span class="feature-tag">Competitive</span>
            </div>
            <button class="game-action signup">Sign Up to Play</button>
            
            <div class="preview-overlay">
              <div class="preview-content">
                <div class="preview-title">Competitive Excellence</div>
                <div class="preview-text">Real-time presentation battles</div>
              </div>
            </div>
          </div>

          <div class="game-card" id="philosophyFlowCard">
            <div class="game-header">
              <div class="game-icon">🧠</div>
              <div class="game-status premium">Guest+</div>
            </div>
            <h3 class="game-title">Philosophy Flow</h3>
            <p class="game-description">Strategic thinking and framework application. Develop executive decision-making through philosophical reasoning challenges.</p>
            <div class="game-features">
              <span class="feature-tag">Strategic Thinking</span>
              <span class="feature-tag">Frameworks</span>
              <span class="feature-tag">Logic</span>
            </div>
            <button class="game-action play">Try Premium</button>
            
            <div class="preview-overlay">
              <div class="preview-content">
                <div class="preview-title">Strategic Mastery</div>
                <div class="preview-text">Framework application and reasoning</div>
              </div>
            </div>
          </div>

          <div class="game-card" id="classifyTechCard">
            <div class="game-header">
              <div class="game-icon">🔬</div>
              <div class="game-status available">Available</div>
            </div>
            <h3 class="game-title">Classify Tech</h3>
            <p class="game-description">Technology categorization and emerging tech identification. Build expertise in AI, cloud platforms, and innovation assessment.</p>
            <div class="game-features">
              <span class="feature-tag">Tech Analysis</span>
              <span class="feature-tag">Innovation</span>
              <span class="feature-tag">Classification</span>
            </div>
            <button class="game-action play">Play Now</button>
            
            <div class="preview-overlay">
              <div class="preview-content">
                <div class="preview-title">Technology Intelligence</div>
                <div class="preview-text">Emerging tech identification and analysis</div>
              </div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 64px; padding: 32px; background: rgba(255, 255, 255, 0.02); border-radius: 16px; border: 1px solid rgba(255, 255, 255, 0.1);">
          <h3 style="font-size: 24px; font-weight: 600; margin-bottom: 16px; color: white;">Ready to Master Executive Excellence?</h3>
          <p style="font-size: 16px; color: rgba(255, 255, 255, 0.8); margin-bottom: 24px;">Join thousands of executives developing world-class digital proficiency</p>
          <button class="cta-button primary" id="fullAccessBtn" style="font-size: 18px; padding: 20px 40px;">Get Full Access</button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    // Add event listeners after DOM is ready with extra delay for ribbon navigation scenarios
    setTimeout(() => {
      console.log("MainMenuSceneUniversal: Setting up event listeners...");
      this.setupEventListeners();
    }, 150); // Slightly longer delay to ensure DOM is fully ready
  }

  addUniversalStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 48px;
        background: rgba(255, 255, 255, 0.02);
        backdrop-filter: blur(10px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      .logo {
        font-size: 28px;
        font-weight: 800;
        background: linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .auth-buttons {
        display: flex;
        gap: 16px;
      }

      .auth-button {
        padding: 12px 24px;
        border: 2px solid #00d4ff;
        border-radius: 8px;
        background: transparent;
        color: #00d4ff;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .auth-button:hover {
        background: #00d4ff;
        color: #0f172a;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 212, 255, 0.3);
      }

      .auth-button.primary {
        background: linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%);
        color: white;
        border: none;
      }

      .auth-button.primary:hover {
        background: linear-gradient(135deg, #00c4ef 0%, #0d94d9 100%);
        transform: translateY(-2px);
      }

      .hero-section {
        text-align: center;
        padding: 80px 48px;
        max-width: 1200px;
        margin: 0 auto;
      }

      .hero-title {
        font-size: 56px;
        font-weight: 800;
        margin-bottom: 24px;
        background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: 1.1;
      }

      .hero-subtitle {
        font-size: 22px;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 48px;
        line-height: 1.5;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
      }

      .cta-buttons {
        display: flex;
        gap: 24px;
        justify-content: center;
        margin-bottom: 80px;
      }

      .cta-button {
        padding: 18px 36px;
        border-radius: 12px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        text-decoration: none;
        display: inline-block;
        border: none;
      }

      .cta-button.primary {
        background: linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%);
        color: white;
        box-shadow: 0 8px 25px rgba(0, 212, 255, 0.3);
      }

      .cta-button.primary:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 35px rgba(0, 212, 255, 0.4);
        background: linear-gradient(135deg, #00c4ef 0%, #0d94d9 100%);
      }

      .cta-button.secondary {
        background: transparent;
        color: white;
        border: 2px solid rgba(255, 255, 255, 0.2);
      }

      .cta-button.secondary:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(255, 255, 255, 0.3);
        transform: translateY(-3px);
      }

      .games-section {
        padding: 0 48px 80px 48px;
        max-width: 1400px;
        margin: 0 auto;
      }

      .section-title {
        text-align: center;
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 16px;
        color: white;
      }

      .section-subtitle {
        text-align: center;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 48px;
      }

      .games-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 24px;
      }

      .game-card {
        background: rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 16px;
        padding: 28px;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .game-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        border-color: rgba(0, 212, 255, 0.3);
        background: rgba(255, 255, 255, 0.08);
      }

      .game-card.locked {
        opacity: 0.6;
        cursor: not-allowed;
      }

      .game-card.locked:hover {
        transform: none;
        box-shadow: none;
      }

      .game-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
      }

      .game-icon {
        font-size: 48px;
        margin-bottom: 16px;
      }

      .game-status {
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
      }

      .game-status.available {
        background: rgba(16, 185, 129, 0.2);
        color: #10b981;
        border: 1px solid rgba(16, 185, 129, 0.3);
      }

      .game-status.locked {
        background: rgba(239, 68, 68, 0.2);
        color: #ef4444;
        border: 1px solid rgba(239, 68, 68, 0.3);
      }

      .game-status.premium {
        background: rgba(168, 85, 247, 0.2);
        color: #a855f7;
        border: 1px solid rgba(168, 85, 247, 0.3);
      }

      .game-title {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 12px;
        color: white;
      }

      .game-description {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .game-features {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 20px;
      }

      .feature-tag {
        background: rgba(0, 212, 255, 0.1);
        color: #00d4ff;
        padding: 4px 12px;
        border-radius: 16px;
        font-size: 11px;
        font-weight: 600;
        border: 1px solid rgba(0, 212, 255, 0.2);
      }

      .game-action {
        width: 100%;
        padding: 14px;
        border: none;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .game-action.play {
        background: linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%);
        color: white;
      }

      .game-action.play:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 212, 255, 0.4);
      }

      .game-action.locked {
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.5);
        cursor: not-allowed;
      }

      .game-action.signup {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
      }

      .game-action.signup:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
      }

      .guest-notice {
        background: rgba(168, 85, 247, 0.1);
        border: 1px solid rgba(168, 85, 247, 0.2);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 32px;
        text-align: center;
      }

      .guest-notice h3 {
        color: #a855f7;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
      }

      .guest-notice p {
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        line-height: 1.5;
      }

      .preview-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 212, 255, 0.05);
        backdrop-filter: blur(2px);
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      .game-card:hover .preview-overlay {
        opacity: 1;
      }

      .preview-content {
        text-align: center;
        color: white;
        padding: 20px;
      }

      .preview-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 8px;
      }

      .preview-text {
        font-size: 12px;
        opacity: 0.9;
      }
    `;
    document.head.appendChild(style);
  }

  setupEventListeners() {
    if (!this.sceneReady) {
      setTimeout(() => this.setupEventListeners(), 100);
      return;
    }

    // CRITICAL FIX: Prevent infinite recursion by being more careful about re-attachment  
    if (this.eventListenersAttached) {
      console.log("MainMenuSceneUniversal: Event listeners already attached, skipping re-attachment");
      return;
    }
    
    console.log("MainMenuSceneUniversal: Attaching event listeners...");
    this.eventListenersAttached = true;

    // Header auth buttons
    const signInBtn = document.getElementById('signInBtn');
    const signUpBtn = document.getElementById('signUpBtn');
    
    if (signInBtn) {
      signInBtn.addEventListener('click', () => this.showSignIn());
    }
    if (signUpBtn) {
      signUpBtn.addEventListener('click', () => this.showSignUp());
    }

    // Hero CTA buttons
    const startTrialBtn = document.getElementById('startTrialBtn');
    const exploreBtn = document.getElementById('exploreBtn');
    
    if (startTrialBtn) {
      startTrialBtn.addEventListener('click', () => this.startTrial());
    }
    if (exploreBtn) {
      exploreBtn.addEventListener('click', () => this.exploreGames());
    }

    // Game cards - Enhanced attachment with debugging
    const gameCardConfigs = [
      { id: 'pptHeroCard', action: () => this.playGame('ppt-hero') },
      { id: 'slideWarsCard', action: () => this.showSignUpPrompt('slide-wars') },
      { id: 'philosophyFlowCard', action: () => this.playGame('philosophy-flow') },
      { id: 'classifyTechCard', action: () => this.playGame('classify-tech') }
    ];
    
    let attachedCount = 0;
    
    gameCardConfigs.forEach(config => {
      const card = document.getElementById(config.id);
      if (card) {
        // CRITICAL FIX: Use a more direct approach to ensure click handlers work
        
        // Method 1: Direct onclick assignment (most reliable)
        card.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log(`🎮 MainMenuSceneUniversal: Game card clicked - ${config.id}`);
          config.action();
        };
        
        // Method 2: Also add addEventListener as backup
        card.addEventListener('click', config.action, { passive: false });
        
        attachedCount++;
        console.log(`✅ MainMenuSceneUniversal: Dual event listeners attached to ${config.id}`);
      } else {
        console.warn(`🚨 MainMenuSceneUniversal: Game card ${config.id} not found in DOM!`);
      }
    });
    
    console.log(`✅ MainMenuSceneUniversal: ${attachedCount}/${gameCardConfigs.length} game card listeners attached successfully`);

    // Full access button
    const fullAccessBtn = document.getElementById('fullAccessBtn');
    if (fullAccessBtn) {
      fullAccessBtn.addEventListener('click', () => this.startFullAccess());
    }

    console.log("✅ MainMenuSceneUniversal: All event listeners attached successfully");
    
    // Simple DOM verification without triggering recursion
    this.verifyGameCardClickability();
  }

  verifyGameCardClickability() {
    // CRITICAL FIX: Now verify using onclick property (which we set directly)
    const gameCards = ['pptHeroCard', 'slideWarsCard', 'philosophyFlowCard', 'classifyTechCard'];
    let clickableCount = 0;
    let foundCount = 0;
    
    gameCards.forEach(cardId => {
      const card = document.getElementById(cardId);
      if (card) {
        foundCount++;
        if (card.onclick) {
          clickableCount++;
        } else {
          console.warn(`🚨 MainMenuSceneUniversal: Game card ${cardId} found but onclick not set!`);
        }
      } else {
        console.warn(`🚨 MainMenuSceneUniversal: Game card ${cardId} not found in DOM!`);
      }
    });
    
    console.log(`✅ MainMenuSceneUniversal: ${foundCount}/${gameCards.length} game cards found, ${clickableCount} clickable`);
    
    // If some cards aren't clickable, wait a bit and try once more (but not infinitely)
    if (clickableCount < foundCount && !this.retriedEventAttachment) {
      console.warn('🔄 MainMenuSceneUniversal: Some cards not clickable, retrying once...');
      this.retriedEventAttachment = true;
      setTimeout(() => {
        this.eventListenersAttached = false;
        this.setupEventListeners();
      }, 500);
    } else if (this.retriedEventAttachment) {
      console.log('✅ MainMenuSceneUniversal: Event attachment retry completed');
    }
  }

  // Navigation methods
  async showSignIn() {
    console.log('MainMenuSceneUniversal: Opening sign in...');
    try {
      // ENTERPRISE REFACTOR: Use unified authentication service
      if (window.enterpriseAuthService) {
        console.log("🏢 Using EnterpriseAuthService for sign in");
        await window.enterpriseAuthService.showAuthentication('signin');
      } else {
        console.warn("🏢 EnterpriseAuthService not available, using fallback");
        // Fallback to existing auth system
        if (window.authUI && window.authUI.showAuthOverlay) {
          window.authUI.showAuthOverlay('signin');
        } else {
          console.warn('MainMenuSceneUniversal: AuthUI not available or showAuthOverlay method missing');
          // Final fallback - try to show auth overlay directly
          const authOverlay = document.getElementById('auth-overlay');
          if (authOverlay) {
            authOverlay.classList.add('show');
          }
        }
      }
    } catch (e) {
      console.error("Error showing sign in:", e);
    }
  }

  async showSignUp() {
    console.log('MainMenuSceneUniversal: Opening sign up...');
    try {
      // ENTERPRISE REFACTOR: Use unified authentication service
      if (window.enterpriseAuthService) {
        console.log("🏢 Using EnterpriseAuthService for sign up");
        await window.enterpriseAuthService.showAuthentication('signup');
      } else {
        console.warn("🏢 EnterpriseAuthService not available, using fallback");
        // Fallback to existing auth system
        if (window.authUI && window.authUI.showAuthOverlay) {
          window.authUI.showAuthOverlay('signup');
        } else {
          console.warn('MainMenuSceneUniversal: AuthUI not available or showAuthOverlay method missing');
          // Final fallback - try to show auth overlay directly
          const authOverlay = document.getElementById('auth-overlay');
          if (authOverlay) {
            authOverlay.classList.add('show');
          }
        }
      }
    } catch (e) {
      console.error("Error showing sign up:", e);
    }
  }

  startTrial() {
    console.log('MainMenuSceneUniversal: Starting free trial...');
    this.showSignUp(); // Same as sign up for now
  }

  exploreGames() {
    console.log('MainMenuSceneUniversal: Scrolling to games...');
    const gamesSection = document.querySelector('.games-section');
    if (gamesSection) {
      gamesSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  playGame(gameId) {
    console.log(`🔍 MainMenuSceneUniversal: Game action requested - ${gameId}`, {
      sceneReady: this.sceneReady,
      eventListenersAttached: this.eventListenersAttached,
      inputEnabled: this.input?.enabled,
      isTransitioning: this.isTransitioning || false,
      sceneManagerTransitioning: window.sceneManager?.isTransitioning || false,
      sceneManagerCooldown: window.sceneManager?.transitionCooldown || false
    });
    
    if (!this.sceneReady) {
      console.warn('🚨 MainMenuSceneUniversal: BLOCKING game action - scene not ready:', gameId);
      console.warn('🚨 This suggests the scene was not properly initialized after ribbon navigation');
      return;
    }
    
    console.log(`✅ MainMenuSceneUniversal: Processing game launch for: ${gameId}`);
    
    // Clean up DOM before transitioning
    this.removeExistingOverlay();
    this.showGameContainer();
    
    // Use SceneManager for consistent transitions instead of direct scene.start
    const sceneManager = window.sceneManager;
    
    // Route to appropriate game scene
    switch (gameId) {
      case 'ppt-hero':
        console.log(`MainMenuSceneUniversal: Starting PPT Hero using proper PPTHeroSceneManager`);
        
        // NOW is the right time to clean up DOM styles for Phaser transition
        import('../services/CSSPollutionManager.js').then(cssModule => {
          const CSSPollutionManager = cssModule.default;
          const manager = CSSPollutionManager.getInstance();
          manager.cleanupForPhaserTransition(); // Targeted cleanup for Phaser
        }).catch(e => console.warn('CSS cleanup failed:', e));
        
        // CRITICAL FIX: Use the same robust pattern as other menu scenes
        import('./ppt-hero/PPTHeroSceneManager.js').then(module => {
          const PPTHeroSceneManager = module.default;
          PPTHeroSceneManager.startPPTHero(this, 'generic');
        }).catch(error => {
          console.error('MainMenuSceneUniversal: Error loading PPT Hero:', error);
          // Fallback to direct scene transition if PPTHeroSceneManager fails
          if (sceneManager) {
            sceneManager.switchToScene('PPTHeroGenericScene');
          } else {
            this.scene.start('PPTHeroGenericScene');
          }
        });
        break;
      case 'philosophy-flow':
        // Clean up DOM styles before Phaser transition
        import('../services/CSSPollutionManager.js').then(cssModule => {
          const manager = cssModule.default.getInstance();
          manager.cleanupForPhaserTransition();
        }).catch(e => console.warn('CSS cleanup failed:', e));
        
        if (this.scene.manager.getScene('PhilosophyFlowScene')) {
          console.log(`MainMenuSceneUniversal: Switching to PhilosophyFlowScene via SceneManager`);
          if (sceneManager) {
            sceneManager.switchToScene('PhilosophyFlowScene');
          } else {
            this.scene.start('PhilosophyFlowScene');
          }
        } else {
          console.error(`MainMenuSceneUniversal: PhilosophyFlowScene not found!`);
        }
        break;
      case 'classify-tech':
        // Clean up DOM styles before Phaser transition
        import('../services/CSSPollutionManager.js').then(cssModule => {
          const manager = cssModule.default.getInstance();
          manager.cleanupForPhaserTransition();
        }).catch(e => console.warn('CSS cleanup failed:', e));
        
        if (this.scene.manager.getScene('ClassifyScene')) {
          console.log(`MainMenuSceneUniversal: Switching to ClassifyScene via SceneManager`);
          if (sceneManager) {
            sceneManager.switchToScene('ClassifyScene');
          } else {
            this.scene.start('ClassifyScene');
          }
        } else {
          console.error(`MainMenuSceneUniversal: ClassifyScene not found!`);
        }
        break;
      default:
        console.warn(`MainMenuSceneUniversal: Game ${gameId} not implemented yet`);
    }
  }

  showSignUpPrompt(gameId) {
    console.log(`MainMenuSceneUniversal: Showing signup prompt for ${gameId}...`);
    
    // Create a professional signup prompt overlay
    const promptOverlay = document.createElement('div');
    promptOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.8);
      z-index: 15000;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    
    promptOverlay.innerHTML = `
      <div style="background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); padding: 40px; border-radius: 20px; max-width: 500px; text-align: center; border: 1px solid rgba(255, 255, 255, 0.1);">
        <h3 style="color: #00d4ff; font-size: 24px; margin-bottom: 16px;">🚀 Unlock ${gameId === 'slide-wars' ? 'Slide Wars' : gameId}</h3>
        <p style="color: rgba(255, 255, 255, 0.8); margin-bottom: 24px; line-height: 1.5;">Sign up to access competitive multiplayer features, detailed analytics, and compete with executives worldwide.</p>
        <div style="display: flex; gap: 16px; justify-content: center;">
          <button onclick="this.parentElement.parentElement.parentElement.remove(); document.getElementById('signUpBtn').click();" style="background: linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%); color: white; border: none; padding: 12px 24px; border-radius: 8px; font-weight: 600; cursor: pointer;">Get Started</button>
          <button onclick="this.parentElement.parentElement.parentElement.remove();" style="background: transparent; color: rgba(255, 255, 255, 0.7); border: 1px solid rgba(255, 255, 255, 0.2); padding: 12px 24px; border-radius: 8px; cursor: pointer;">Maybe Later</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(promptOverlay);
  }

  startFullAccess() {
    console.log('MainMenuSceneUniversal: Starting full access signup...');
    this.showSignUp();
  }

  // Utility methods (same as other DOM scenes)
  hideGameContainer() {
    const gameContainer = document.getElementById('game-container');
    if (gameContainer) {
      gameContainer.style.display = 'none';
      gameContainer.style.visibility = 'hidden';
    }
  }

  showGameContainer() {
    const gameContainer = document.getElementById('game-container');
    if (gameContainer) {
      // CRITICAL: Restore PPT Hero expected positioning (matching MainMenuSceneDOM pattern)
      gameContainer.style.visibility = 'visible';
      gameContainer.style.display = 'block';
      gameContainer.style.top = '50px';
      gameContainer.style.height = 'calc(100% - 50px)';
      gameContainer.style.opacity = '1';
      gameContainer.style.filter = 'none';
      
      // Also ensure top ribbon is visible (PPT Hero dependency)
      const topRibbon = document.getElementById("top-ribbon");
      if (topRibbon) {
        topRibbon.style.display = 'flex';
      }
      
      // CRITICAL: Canvas styling for Rex UI (from PPT Hero requirements)
      const canvas = document.querySelector('canvas');
      if (canvas) {
        canvas.style.opacity = '1';
        canvas.style.filter = 'none';
        canvas.style.touchAction = "pan-y"; // FIXED: Allow mobile scrolling
      }
      
      // CRITICAL: Call CanvasFixer (PPT Hero dependency)
      try {
        if (window.CanvasFixer && typeof window.CanvasFixer.fixAndFocusCanvas === 'function') {
          window.CanvasFixer.fixAndFocusCanvas();
        }
      } catch (e) {
        console.warn("MainMenuSceneUniversal: Error calling CanvasFixer:", e);
      }
      
      // CRITICAL: Only clean up CSS when actually launching Phaser games
      // this.cleanupCSSPollution(); // Don't clean our own styles!
      
      console.log('MainMenuSceneUniversal: Complete Rex UI environment restored with CSS cleanup');
    }
  }

  removeExistingOverlay() {
    const existingOverlay = document.getElementById(this.overlayId);
    if (existingOverlay) {
      existingOverlay.remove();
    }
    this.cleanupCSSPollution();
  }

  cleanupCSSPollution() {
    // CRITICAL FIX: MainMenuSceneUniversal IS a DOM scene - don't remove its own styles!
    // Only clean up when transitioning AWAY from this scene to Phaser scenes
    console.log('MainMenuSceneUniversal: Skipping CSS cleanup - this IS a DOM scene that needs its styles');
    
    // Only clean up problematic styles that interfere with canvas/input, not layout styles
    const styleElements = document.querySelectorAll('style');
    let removedCount = 0;
    
    styleElements.forEach(style => {
      const content = style.textContent || '';
      // Only remove styles that specifically interfere with canvas interaction
      if (content.includes('pointer-events: none') || 
          content.includes('touch-action: manipulation') ||
          (content.includes('position: fixed') && content.includes('canvas'))) {
        style.remove();
        removedCount++;
      }
    });
    
    console.log(`MainMenuSceneUniversal: Selective cleanup removed ${removedCount} canvas-interfering styles`);
  }

  shutdown() {
    console.log("MainMenuSceneUniversal: Shutting down...");
    
    // CRITICAL FIX: Reset all state flags for proper re-initialization after ribbon navigation
    this.sceneReady = false;
    this.eventListenersAttached = false;
    this.retriedEventAttachment = false; // Reset retry flag
    console.log("MainMenuSceneUniversal: All state flags reset during shutdown for clean restart");
    
    this.removeExistingOverlay();
    this.showGameContainer();
  }

  destroy() {
    console.log("MainMenuSceneUniversal: Destroying...");
    
    // CRITICAL FIX: Reset all state flags for proper re-initialization
    this.sceneReady = false;
    this.eventListenersAttached = false;
    this.retriedEventAttachment = false; // Reset retry flag
    console.log("MainMenuSceneUniversal: All state flags reset during destroy for clean restart");
    
    this.removeExistingOverlay();
    this.showGameContainer();
  }
}

export default MainMenuSceneUniversal;
